// import Breadcrumb from '@components/Shared/Breadcrumb';
// import { Card, CardBody } from '@components/card/card';
// import { useTranslation } from 'react-i18next';
// import { Link } from 'react-router-dom';
// import Loading from '@components/Shared/Loader/Loading';

// import useGetArTransactionsList from '@hooks/AR/ArTransactions/useGetArTransactionsList';
// import NtxTable from '@components/DataTable/NtxTable';

// const Index = () => {
//   const { t, i18n } = useTranslation();

//   const { ArTransactionsList, loading, error } = useGetArTransactionsList();

//   const columns = [
//     { title: t('InvoiceNumber'), key: 'invoiceNum' },
//     { title: t('Customer'), key: 'peopleName' },
//     { title: t('InvoiceDate'), key: 'invoiceDate' },
//     { title: t('InvoiceType'), key: 'invoiceType' },
//     { title: t('Branch'), key: 'organizationName' },
//     { title: t('Amount'), key: 'invoiceAmount' },
//     { title: t('PostingStatus'), key: 'postedFlag', className: 'text-center' }, // إضافة حالة الترحيل

//     { title: '', key: 'action', className: 'text-end' }
//   ];

//   const tableData = ArTransactionsList?.map((item: any) => {
//     let rowClass;

//     // تحديد الشارة بناءً على قيمة postedFlag
//     const postedFlagBadge = item.postedFlag ? (
//       <span className='badge bg-success'>
//         <i className='fas fa-check me-1'></i>
//         {t('Posted')}
//       </span>
//     ) : (
//       <span className='badge bg-danger'>
//         <i className='fas fa-times me-1'></i>
//         {t('NotPosted')}
//       </span>
//     );
//     return {
//       invoiceNum: item.transactionNum,
//       peopleName: i18n.language === 'en' ? item.peopleName : item.peopleName2,
//       invoiceDate: item.transactionDate,
//       invoiceType: item.transactionType,
//       organizationName: i18n.language === 'en' ? item.organizationName : item.organizationName2,
//       invoiceAmount: item.transactionAmount,
//       postedFlag: postedFlagBadge, // استخدام الشارة هنا
//       action: (
//         <Link to={`${item.id}/UpdateArTransactions`} className='btn btn-outline-theme mx-1'>
//           <i className='fas fa-info-circle me-2'></i>
//           {t('Details')}
//         </Link>
//       ),
//       rowClass // استخدم rowClass هنا
//     };
//   });

//   //____________________________

//   return (
//     <div>
//       <div className='d-flex align-items-center'>
//         <Breadcrumb
//           BreadcrumbList={[
//             {
//               name: 'Home',
//               link: ':moduleHome'
//             },

//             {
//               name: 'ReceivableInvoices',
//               link: null
//             }
//           ]}
//           PageName='ReceivableInvoices'
//         />

//         <div className='ms-auto'>
//           <Link to='AddArTransactions' className='btn me-1 btn-theme'>
//             <i className='fa fa-plus-circle fa-fw me-1'></i>
//             {t('NewInvoice')}
//           </Link>
//         </div>
//       </div>
//       <Card>
//         <Loading loading={loading} error={error}>
//           <CardBody>
//             <div className=' p-2'>
//               <NtxTable
//                 data={tableData || []}
//                 columns={columns}
//                 dataPerPage={10}
//                 theadClass=''
//                 tableClass='table text-nowrap table-hover '
//                 enableSearch={true}
//                 showRecordsSelector
//               />
//             </div>
//           </CardBody>
//         </Loading>
//       </Card>
//     </div>
//   );
// };

// export default Index;

// //  "referenceType": "Sales_Order",
// //  "referenceType": "Sale_Order_POS",
// //   "referenceType": 'Manual',

import { useState } from 'react';
import Breadcrumb from '@components/Shared/Breadcrumb';
import { Card, CardBody } from '@components/card/card';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Loading from '@components/Shared/Loader/Loading';
import useGetArTransactionsList from '@hooks/AR/ArTransactions/useGetArTransactionsList';
import NtxTable from '@components/DataTable/NtxTable';

const Index = () => {
  const { t, i18n } = useTranslation();
  const { ArTransactionsList, loading, error } = useGetArTransactionsList();

  // دالة للحصول على شارة حالة الترحيل
  const getPostedFlagBadge = (flag: boolean) =>
    flag ? (
      <span className='badge bg-success'>
        <i className='fas fa-check me-1'></i>
        {t('Posted')}
      </span>
    ) : (
      <span className='badge bg-danger'>
        <i className='fas fa-times me-1'></i>
        {t('NotPosted')}
      </span>
    );

  // دالة للحصول على شارة نوع الفاتورة
  const getInvoiceTypeBadge = (type: string) => {
    switch (type) {
      case 'Standard':
        return (
          <span className='badge bg-primary'>
            <i className='fas fa-file-invoice me-1'></i>
            {t('Standard')}
          </span>
        );
      case 'CreditMemo':
      case 'DebitMemo':
        return (
          <span className='badge bg-warning text-dark'>
            <i className='fas fa-file-invoice-dollar me-1'></i>
            {t('CreditMemo')}
          </span>
        );
      default:
        return (
          <span className='badge bg-secondary'>
            <i className='fas fa-file me-1'></i>
            {type}
          </span>
        );
    }
  };

  // دالة للحصول على شارة نوع المرجع
  // const getReferenceTypeBadge = (refType: string) => {
  //   switch (refType) {
  //     case 'Sales_Order':
  //       return (
  //         <span className='badge bg-success'>
  //           <i className='fas fa-shopping-cart me-1'></i>
  //           {t('أمر بيــع')}
  //         </span>
  //       );
  //     case 'Sale_Order_POS':
  //       return (
  //         <span className='badge bg-info'>
  //           <i className='fas fa-cash-register me-1'></i>
  //           {t('مبيعات نقاط بيـع')}
  //         </span>
  //       );
  //     case 'Sale_Returns_POS':
  //       return (
  //         <span className='badge bg-info'>
  //           <i className='fas fa-cash-register me-1'></i>
  //           {t('مردودات نقاط بيع')}
  //         </span>
  //       );
  //     case 'Discount':
  //       return (
  //         <span className='badge bg-info'>
  //           <i className='fas fa-cash-register me-1'></i>
  //           {t('خصــم')}
  //         </span>
  //       );
  //     case 'Manual':
  //       return (
  //         <span className='badge bg-dark'>
  //           <i className='fas fa-keyboard me-1'></i>
  //           {t('يدوي')}
  //         </span>
  //       );
  //     default:
  //       return (
  //         <span className='badge bg-secondary'>
  //           <i className='fas fa-receipt me-1'></i>
  //           {refType}
  //         </span>
  //       );
  //   }
  // };

  // دالة للحصول على شارة نوع المرجع
  const getReferenceTypeBadge = (refType: string) => {
    switch (refType) {
      case 'Sales_Order':
        return (
          <span className='badge bg-success'>
            <i className='fas fa-shopping-cart me-1'></i>
            {t('أمر بيــع')}
          </span>
        );
      // case 'Sale_Order_POS':
      //   return (
      //     <span className='badge bg-info'>
      //       <i className='fas fa-cash-register me-1'></i>
      //       {t('مبيعات نقاط بيـع')}
      //     </span>
      //   );
      // case 'Sale_Returns_POS':
      //   return (
      //     <span className='badge bg-info'>
      //       <i className='fas fa-cash-register me-1'></i>
      //       {t('مردودات نقاط بيع')}
      //     </span>
      //   );

      case 'Sale_Order_POS':
        return (
          <span className='badge bg-info'>
            <i className='fas fa-cash-register me-1'></i>
            {t('مبيعات نقاط بيـع')}
          </span>
        );
      case 'Sale_Returns_POS':
        return (
          <span className='badge bg-secondary'>
            <i className='fas fa-undo-alt me-1'></i>
            {t('مردودات نقاط بيع')}
          </span>
        );
      case 'Discount':
        return (
          <span className='badge bg-info'>
            <i className='fas fa-cash-register me-1'></i>
            {t('خصــم')}
          </span>
        );
      // ---------- الحالات الجديدة ----------
      case 'Sett_POS_Shortage':
        return (
          <span className='badge bg-danger'>
            <i className='fas fa-arrow-down me-1'></i>
            {t('عجز نقاط بيع')}
          </span>
        );
      case 'Sett_POS_Overage':
        return (
          <span className='badge bg-warning text-dark'>
            <i className='fas fa-arrow-up me-1'></i>
            {t('فائض نقاط بيع')}
          </span>
        );
      // -------------------------------------
      case 'Manual':
        return (
          <span className='badge bg-dark'>
            <i className='fas fa-keyboard me-1'></i>
            {t('يدوي')}
          </span>
        );
      default:
        return (
          <span className='badge bg-secondary'>
            <i className='fas fa-receipt me-1'></i>
            {refType}
          </span>
        );
    }
  };

  // دالة للحصول على شارة حالة الدفع
  const getPaymentFlagBadge = (flag: boolean) =>
    flag ? (
      <span className='badge bg-success'>
        <i className='fas fa-check-double me-1'></i>
        {t('مدفوعة')} {/* أو t('Paid') إذا كنت تستخدم الترجمة */}
      </span>
    ) : (
      <span className='badge bg-warning text-dark'>
        <i className='fas fa-clock me-1'></i>
        {t('غير مدفوعة')} {/* أو t('Unpaid') */}
      </span>
    );

  // دالة لتنسيق المبالغ
  const formatAmount = (amount: number) => {
    return new Intl.NumberFormat(i18n.language, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);
  };

  const columns = [
    { title: t('InvoiceNumber'), key: 'invoiceNum' },
    { title: t('Customer'), key: 'peopleName' },
    { title: t('InvoiceDate'), key: 'invoiceDate' },
    { title: t('Branch'), key: 'organizationName' },
    { title: t('Amount'), key: 'invoiceAmount' },
    {
      title: t('InvoiceType'),
      key: 'invoiceType',
      sortValue: (row: any) => row.invoiceType_sort
    },
    {
      title: t('المصدر'),
      key: 'referenceType',
      sortValue: (row: any) => row.referenceType_sort
    },
    {
      title: t('PostingStatus'),
      key: 'postedFlag',
      className: 'text-center',
      sortValue: (row: any) => row.postedStatus
    },
    // --- العمود الجديد لحالة الدفع ---
    {
      title: t('حالة الدفع'), // يمكنك استبدالها بـ t('PaymentStatus')
      key: 'paymentFlag',
      className: 'text-center',
      sortValue: (row: any) => row.paymentStatus
    },
    { title: '', key: 'action', className: 'text-end' }
  ];

  // const tableData = ArTransactionsList?.map((item: any) => ({
  //   invoiceNum: item.transactionNum,
  //   peopleName: i18n.language === 'en' ? item.peopleName : item.peopleName2,
  //   invoiceDate: item.transactionDate,
  //   invoiceType: getInvoiceTypeBadge(item.transactionType || 'Standard'),
  //   referenceType: getReferenceTypeBadge(item.referenceType || 'Manual'),
  //   organizationName: i18n.language === 'en' ? item.organizationName : item.organizationName2,
  //   invoiceAmount: <span className='fw-bold text-theme'>{formatAmount(item.transactionAmount)}</span>,
  //   postedFlag: getPostedFlagBadge(item.postedFlag || false),
  //   // قيم الترتيب
  //   postedStatus: item.postedFlag ? 1 : 0,
  //   invoiceType_sort: item.transactionType,
  //   referenceType_sort: item.referenceType,


  //   action: (
  //     <Link to={`${item.id}/UpdateArTransactions`} className='btn btn-sm btn-outline-theme mx-1'>
  //       <i className='fas fa-info-circle fa-lg'></i>
  //     </Link>
  //   ),
  //   rowClass: undefined
  // }));



  const tableData = ArTransactionsList?.map((item: any) => ({
    invoiceNum: item.transactionNum,
    peopleName: i18n.language === 'en' ? item.peopleName : item.peopleName2,
    invoiceDate: item.transactionDate,
    invoiceType: getInvoiceTypeBadge(item.transactionType || 'Standard'),
    referenceType: getReferenceTypeBadge(item.referenceType || 'Manual'),
    organizationName: i18n.language === 'en' ? item.organizationName : item.organizationName2,
    invoiceAmount: <span className='fw-bold text-theme'>{formatAmount(item.transactionAmount)}</span>,
    
    postedFlag: getPostedFlagBadge(item.postedFlag || false),
    // --- ربط حقل الدفع الجديد ---
    paymentFlag: getPaymentFlagBadge(item.paymentFlag || false), 
    
    // قيم الترتيب
    postedStatus: item.postedFlag ? 1 : 0,
    paymentStatus: item.paymentFlag ? 1 : 0, // قيمة ترتيب حالة الدفع
    invoiceType_sort: item.transactionType,
    referenceType_sort: item.referenceType,
    action: (
      <Link to={`${item.id}/UpdateArTransactions`} className='btn btn-sm btn-outline-theme mx-1'>
        <i className='fas fa-info-circle fa-lg'></i>
      </Link>
    ),
    rowClass: undefined
  }));
  
  return (
    <div>
      <div className='d-flex align-items-center'>
        <Breadcrumb
          BreadcrumbList={[
            {
              name: 'Home',
              link: ':moduleHome'
            },
            {
              name: 'ReceivableInvoices',
              link: null
            }
          ]}
          PageName='ReceivableInvoices'
        />

        <div className='ms-auto'>
          <Link to='AddArTransactions' className='btn me-1 btn-theme'>
            <i className='fa fa-plus-circle fa-fw me-1'></i>
            {t('NewInvoice')}
          </Link>
        </div>
      </div>
      <Card>
        <Loading loading={loading} error={error}>
          <CardBody>
            <NtxTable
              data={tableData || []}
              columns={columns}
              dataPerPage={10}
              theadClass=''
              tableClass='table text-nowrap table-hover'
              enableSearch={true}
              showRecordsSelector
            />
          </CardBody>
        </Loading>
      </Card>
    </div>
  );
};

export default Index;
